module.exports = __webpack_public_path__ + "img/二星特级大师@3x.7b3fe45e.png";